import { toast } from "react-hot-toast";

// To display error message
const errorToast = (msg) => {
  toast.dismiss();
  toast.error(msg);
};

const successToast = (msg) => {
  toast.dismiss();
  toast.success(msg);
};

const errorHandler = (error) => {
  if (error?.response?.data) {
    const { data } = error.response;
    const fieldErrors = data?.errors;
    const flattenedFieldErrors =
      fieldErrors && typeof fieldErrors === "object" && !Array.isArray(fieldErrors)
        ? Object.values(fieldErrors).flat().filter(Boolean).join(", ")
        : "";

    const message =
      flattenedFieldErrors ||
      data?.message ||
      data?.errors?.[0]?.msg ||
      data?.error ||
      "Something went wrong.";

    errorToast(
      Array.isArray(message) ? message.join(", ") : message,
    );
    return;
  }

  errorToast(error?.message || "Something went wrong.");
};

export { errorToast, successToast, errorHandler };
